import React, { useEffect, useRef, useState } from "react"
import ReactSVG from "react-svg"
import RightLogo from "../../../images/dashboard/right_arrow.svg"
import ActiveBanner from "../../../images/activate-banner.png"
import { useTranslation } from "react-i18next"
import { Image, Modal, Sidebar } from "semantic-ui-react"
import { isMobile } from "react-device-detect"
import ActivateFuelcardModal from "./ActivateFuelcardModal"
import { BottomSheet } from "react-spring-bottom-sheet"
import "react-spring-bottom-sheet/dist/style.css"
import { trackFirebaseAnalytics } from "../../../shared_component/utils/googleAnalyticsHelpers"

const ActivateFuelcardBanner = ({ fuelCard }) => {
  const { t } = useTranslation("fuelcardRequest")
  const bottomSheetRef = useRef(null)

  const [openActivateDialog, setOpenActivateDialog] = useState(false)
  const [activationSuccessful, setActivationSuccessful] = useState(false)
  const [activateCardVisibility, setActivateCardVisibility] = useState(true)

  const handleActivateFuelCard = () => {
    setOpenActivateDialog((prev) => !prev)
  }

  const closeActivateFuelCard = () => {
    setOpenActivateDialog(false)

    if (!activationSuccessful) {
      trackFirebaseAnalytics("click_activate_fuelcard_abandoned")
    }
  }

  useEffect(() => {
    // If getting activationSuccessful flag value true then removing the banner as well
    if (activationSuccessful) {
      trackFirebaseAnalytics("click_activate_fuelcard_successful")
      setActivateCardVisibility(false)
    }
  }, [openActivateDialog])

  return activateCardVisibility ? (
    <div className="activate-fuelcard-banner">
      <p
        className="fuelcard-header"
        onClick={() => {
          handleActivateFuelCard()
          trackFirebaseAnalytics("click_activate_fuelcard")
        }}
      >
        {t("activateFuelCard")} <ReactSVG className="right-logo" src={RightLogo} wrapper="span" />{" "}
      </p>
      <Image src={ActiveBanner} className="fuelcard-banner" />
      {isMobile ? (
        <BottomSheet
          open={openActivateDialog}
          ref={bottomSheetRef}
          onDismiss={closeActivateFuelCard}
          snapPoints={({ minHeight }) => minHeight}
          expandOnContentDrag={true}
        >
          <ActivateFuelcardModal
            handleDrawer={closeActivateFuelCard}
            showCloseIcon={false}
            setActivationSuccessful={setActivationSuccessful}
            fuelCard={fuelCard}
          />
        </BottomSheet>
      ) : (
        <Modal open={openActivateDialog} className="fuelcard-activate-dialog">
          <Modal.Content>
            <ActivateFuelcardModal
              handleDrawer={closeActivateFuelCard}
              setActivationSuccessful={setActivationSuccessful}
              fuelCard={fuelCard}
            />
          </Modal.Content>
        </Modal>
      )}
    </div>
  ) : null
}

export default ActivateFuelcardBanner
